import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../config/api';
import { useLang } from '../context/LanguageContext';

const Header = () => {
  const { lang, toggleLang, nl } = useLang();
  const [industries, setIndustries] = useState([]);
  const [specializations, setSpecializations] = useState([]);
  const [services, setServices] = useState([]);
  const [headerData, setHeaderData] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const navigate = useNavigate()

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [industriesRes, specializationsRes, servicesRes, headerRes] = await Promise.all([
          axios.get(`${API_BASE_URL}/api/industries`),
          axios.get(`${API_BASE_URL}/api/specializations`),
          axios.get(`${API_BASE_URL}/api/services`),
          axios.get(`${API_BASE_URL}/api/header-footer`)
        ]);

        if (industriesRes.data.success) {
          setIndustries(industriesRes.data.data);
        } else if (Array.isArray(industriesRes.data)) {
          setIndustries(industriesRes.data);
        }
        if (Array.isArray(specializationsRes.data)) {
          setSpecializations(specializationsRes.data);
        }
        if (servicesRes.data.success) {
          setServices(servicesRes.data.data);
        }
        if (headerRes.data.success) {
          setHeaderData(headerRes.data.data.header);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();

    const handleHeaderUpdate = () => {
      fetchData();
    };

    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown')) {
        setActiveDropdown(null);
      }
    };

    window.addEventListener('headerStyleUpdate', handleHeaderUpdate);
    document.addEventListener('click', handleClickOutside);
    
    return () => {
      window.removeEventListener('headerStyleUpdate', handleHeaderUpdate);
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const headerStyle = {
    backgroundColor: headerData?.backgroundColor || '#ffffff',
    color: headerData?.textColor || '#333333',
    '--button-color': headerData?.buttonColor || '#3b82f6',
    '--button-text-color': headerData?.buttonTextColor || '#ffffff',
    '--button-hover-color': headerData?.buttonHoverColor || '#2563eb'
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const toggleDropdown = (dropdownName) => {
    setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
  };

  const closeDropdowns = () => {
    setActiveDropdown(null);
  };

  return (
    <>
      {/* Mobile Menu Overlay */}
      <div className={`mobile-menu-overlay ${isMobileMenuOpen ? 'active' : ''}`} onClick={closeMobileMenu}></div>

      <header className="header" style={headerStyle}>
        <div className="nav-container">
          {/* Logo Section */}
          <div className="nav-logo">
            <Link to="/" className="logo" onClick={closeMobileMenu}>
              <img src="/images/123.png" alt="Aurelia Technologies" className="logo-img" />
            </Link>
          </div>

          {/* Navigation Links Section */}
          <nav className={`nav-menu ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
            {headerData?.navigation?.main?.filter(item => item.isActive !== false).map((item, index) => (
              <div key={index} className="nav-item">
                <Link to={item.href} className="nav-link" onClick={closeMobileMenu}>
                  {nl ? (item.label_nl || item.label) : item.label}
                </Link>
              </div>
            )) || (
                <>
                  <div className="nav-item">
                    <Link to="/" className="nav-link" onClick={closeMobileMenu}>Home</Link>
                  </div>
                  <div className="nav-item">
                    <Link to="/about" className="nav-link" onClick={closeMobileMenu}>About</Link>
                  </div>
                </>
              )}

              <div className="nav-item">
                    <Link to="/services" className="nav-link" onClick={closeMobileMenu}>{nl ? (headerData?.dropdownLabels?.services_nl || headerData?.dropdownLabels?.services || 'Services') : (headerData?.dropdownLabels?.services || 'Services')}</Link>
                  </div>
            <div className='nav-item dropdown'>
              <button
                type="button"
                className="nav-link dropdown-toggle"
                onClick={() => toggleDropdown('products')}>{nl ? (headerData?.dropdownLabels?.products_nl || headerData?.dropdownLabels?.products || 'Products') : (headerData?.dropdownLabels?.products || 'Products')}
                 <i className="fas fa-chevron-down"></i></button>
              <div className={`dropdown-menu ${activeDropdown === 'products' ? 'show' : ''}`}>
                {services.map((service) => (
                  <Link key={service._id} to={`/products/${(nl && service.slug_nl) || service.slug}`} onClick={() => { closeMobileMenu(); closeDropdowns(); }}>{(nl && service.title_nl) || service.title}</Link>
                ))}
                {specializations.length === 0 && services.length === 0 && (
                  <span>Loading products...</span>
                )}
              </div>
            </div>
            {/* hidden as the clinet to remove it for now 
            
            <div className="nav-item dropdown">
              <button
                type="button"
                className="nav-link dropdown-toggle"
                onClick={() => toggleDropdown('industries')}
              >
              {nl ? (headerData?.dropdownLabels?.industries_nl || headerData?.dropdownLabels?.industries || 'Industries') : (headerData?.dropdownLabels?.industries || 'Industries')} <i className="fas fa-chevron-down"></i>
              </button>
              <div className={`dropdown-menu ${activeDropdown === 'industries' ? 'show' : ''}`}>
                {industries.map((industry) => (
                  <Link key={industry._id} to={`/industries/${industry.slug}`} onClick={() => { closeMobileMenu(); closeDropdowns(); }}>{(nl && industry.title_nl) || industry.title}</Link>
                ))}
                {industries.length === 0 && (
                  <span>No industries available</span>
                )}
              </div>
            </div> */}

            
            <div className='nav-item '>
              <button
                type="button"
                className="nav-link dropdown-toggle"
                onClick={() => {navigate('/blog'); closeMobileMenu()}}
              >
                {nl ? (headerData?.dropdownLabels?.blogs_nl || headerData?.dropdownLabels?.blogs || 'Blogs') : (headerData?.dropdownLabels?.blogs || 'Blogs')}
              </button>
            </div>

            <div className="mobile-social">
              <div className="social-icons">
                {headerData?.navigation?.social?.filter(item => item.isActive === true && item.href).map((item, index) => (
                  <a key={index} href={item.href} className="social-link" target="_blank" rel="noopener noreferrer">
                    <i className={item.icon}></i>
                  </a>
                ))}
              </div>
              {headerData?.contactButton?.isActive !== false && (
                <Link to={headerData?.contactButton?.href || '/contact'} className="nav-cta mobile-cta" onClick={closeMobileMenu}>
                      {nl ? (headerData?.contactButton?.text_nl || headerData?.contactButton?.text || 'Contact Us') : (headerData?.contactButton?.text || 'Contact Us')}
                </Link>
              )}
            </div>
          </nav>

          {/* Contact & Social Section */}
          <div className="nav-actions">
            <div className="social-icons desktop-social">
              {headerData?.navigation?.social?.filter(item => item.isActive === true && item.href).map((item, index) => (
                <a key={index} href={item.href} className="social-link" target="_blank" rel="noopener noreferrer">
                  <i className={item.icon}></i>
                </a>
              ))}
            </div>
            {headerData?.contactButton?.isActive !== false && (
              <Link to={headerData?.contactButton?.href || '/contact'} className="nav-cta desktop-cta">
                {nl ? (headerData?.contactButton?.text_nl || headerData?.contactButton?.text || 'Contact Us') : (headerData?.contactButton?.text || 'Contact Us')}
              </Link>
            )}
            <div style={{ display: 'flex', borderRadius: '6px', overflow: 'hidden', border: '1px solid #ccc', marginLeft: '8px' }}>
              <button onClick={() => { if (nl) toggleLang(); }} style={{ padding: '6px 12px', border: 'none', cursor: 'pointer', fontWeight: 700, fontSize: '13px', background: !nl ? '#22c55e' : '#f3f4f6', color: !nl ? '#fff' : '#555', transition: 'all 0.2s' }}>EN</button>
              <button onClick={() => { if (!nl) toggleLang(); }} style={{ padding: '6px 12px', border: 'none', cursor: 'pointer', fontWeight: 700, fontSize: '13px', background: nl ? '#22c55e' : '#f3f4f6', color: nl ? '#fff' : '#555', transition: 'all 0.2s' }}>NL</button>
            </div>

            <button className="mobile-menu-toggle" onClick={toggleMobileMenu} aria-label="Toggle mobile menu">
              {isMobileMenuOpen ? (
                <i className="fas fa-times" style={{ fontSize: '20px', color: '#000' }}></i>
              ) : (
                <span className="hamburger">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              )}
            </button>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;